export default "__VITE_ASSET__wVHir0nb__"